import { nodeKeyWithoutId } from "../node/index.js";
import {} from "../rule/index.js";
import {} from "./Mod.js";
export function findRuleByNodes(mod, firstNode, secondNode) {
    const firstKey = nodeKeyWithoutId(firstNode);
    const secondKey = nodeKeyWithoutId(secondNode);
    return (mod.ruleEntries.get(`${firstKey} ${secondKey}`) ||
        mod.ruleEntries.get(`${secondKey} ${firstKey}`));
}
//# sourceMappingURL=findRuleByNodes.js.map